export const LEVEL_COLORS = ["#ff8a8a", "#fb923c", "#facc15", "#4ade80"];

export const ACCURACY_CATEGORIES = {
  independent: {
    title: "يقرأ مستقلًا",
    description:
      "يقرأ الطالب عبارات كبيرة او مجموعة من الكلمات ذات مغزى، وغالبا بسلاسة وتنغيم معبر. ويتوقف عند علامات الترقيم مسترشدا بما عناه المؤلف.",
    color: "#10b981",
    minScore: 95,
  },
  instructional: {
    title: "يقرأ بتوجيه",
    description:
      "يقرأ الطالب بدقة مقبولة، لكنه قد يحتاج إلى بعض التوجيه أو الدعم لفهم الكلمات الصعبة وتطبيق مهارات القراءة.",
    color: "#f59e0b",
    minScore: 90,
  },
  frustration: {
    title: "يقرأ بصعوبة",
    description:
      "يواجه الطالب صعوبة كبيرة في القراءة ويحتاج إلى دعم مستمر ومكثف لفك الترميز وفهم الكلمات والنصوص.",
    color: "#ef4444",
    minScore: 0,
  },
};

export const getAccuracyCategory = (score) => {
  if (score >= 95) return ACCURACY_CATEGORIES.independent;
  if (score >= 90) return ACCURACY_CATEGORIES.instructional;
  return ACCURACY_CATEGORIES.frustration;
};

export const FLUENCY_LEVELS = [
  {
    label: "ضعيفة",
    title: "طلاقة ضعيفة",
    color: "#ff8a8a",
    description:
      "يقرأ الطالب كلمة كلمة ببطء شديد، مع صعوبة في تهجئة الكلمات وتوقفات متكررة وطويلة.",
  },
  {
    label: "محدودة",
    title: "طلاقة محدودة",
    color: "#fb923c",
    description:
      "يقرأ الطالب كلمتين او ثلاث كلمات معا، مع بعض التوقفات والتردد في القراءة.",
  },
  {
    label: "جيدة",
    title: "طلاقة جيدة",
    color: "#facc15",
    description:
      "يقرأ الطالب بجمل قصيرة متدفقة وسرعة مناسبة، مع الالتزام بعلامات الترقيم الأساسية.",
  },
  {
    label: "ممتازة",
    title: "طلاقة ممتازة",
    color: "#4ade80",
    description:
      "يقرأ الطالب بطلاقة كاملة وتعبير صوتي معبر ونبرة مناسبة للمقروء وبدون توقفات غير مبررة.",
  },
];

export const MAX_COMPREHENSION_SCORE = 9;

export const COMPREHENSION_LEVELS = [
  {
    label: "ممتاز",
    check: (score) => score >= 9,
  },
  {
    label: "جيد جداً",
    check: (score) => score >= 7 && score <= 8,
  },
  {
    label: "جيد",
    check: (score) => score >= 5 && score <= 6,
  },
  {
    label: "دون المستوى",
    check: (score) => score < 5,
  },
];

export const getStudentFullName = (studentData) => {
  if (!studentData) return "";
  return `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim();
};
